import Vue from 'vue';
import Portal from './Portal/Portal';

/**
 * @typedef {Object} PopconfirmOptions
 * @property {string | Vue.VNode} content
 * @property {{ label: string | Vue.VNode, value: any, primary?: boolean }[]} options
 * @property {number} clientX
 * @property {number} clientY
 */

const Popconfirm = Vue.extend({
  props: {
    content: {
      type: null,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    clientX: Number,
    clientY: Number
  },
  data() {
    return {
      visible: true,
      popStyle: ''
    };
  },
  render() {
    const h = arguments[0];
    if (!this.visible) return null;

    /** @type {PopconfirmOptions} */
    const {
      content,
      options
    } = this.$props;
    return h(Portal, {
      "ref": "portal"
    }, [h("div", {
      "class": "uc-popconfirm",
      "style": this.popStyle,
      "ref": "contentDiv"
    }, [h("div", {
      "class": "uc-popconfirm-content"
    }, [content]), h("div", {
      "class": "uc-popconfirm-options"
    }, [options.map((it, idx) => h("button", {
      "key": idx,
      "class": {
        'uc-button': true,
        isPrimary: it.primary
      },
      "on": {
        "click": () => this.onClickOption(it.value)
      }
    }, [it.label]))])])]);
  },
  mounted() {
    this.$watch('visible', visible => {
      this.popStyle = 'opacity: 0; left: 0; top: 0;';
      if (visible) setTimeout(this.calcPopStyle, 100);
      if (visible) window.document.addEventListener('click', this.globalClickListener, true);else window.document.removeEventListener('click', this.globalClickListener, true);
    }, {
      immediate: true
    });
  },
  beforeDestroy() {
    if (this.visible) this.visible = false;
  },
  methods: {
    calcPopStyle() {
      const {
        portal
      } = this.$refs;
      if (!portal) return;

      /** @type {PopconfirmOptions} */
      const {
        clientX,
        clientY
      } = this.$props;
      const [newX, newY] = portal.clientToContainerCoordinate(clientX, clientY);
      this.popStyle = `left: ${newX}px; top: ${newY}px`;
    },
    onClickOption(value) {
      this.visible = false;
      this.$emit('answer', value);
    },
    /** @param {MouseEvent} ev */
    globalClickListener(ev) {
      if (!this.visible) return;
      const {
        contentDiv
      } = this.$refs;
      if (contentDiv === ev.target || contentDiv.contains(ev.target)) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      this.visible = false;
      this.$emit('cancel');
    }
  }
});
export default Popconfirm;

/**
 *
 * @param {Vue} parent
 * @param {PopconfirmOptions} opt
 * @returns {Promise<any>}  可能会收到 undefined 表示用户取消了操作
 */
export function showPopconfirm(parent, opt) {
  const tempDiv = document.createElement('div');
  document.body.appendChild(tempDiv);
  let vueInst = null;
  const promise = new Promise(resolve => {
    const {
      ...props
    } = opt;
    vueInst = new Vue({
      el: tempDiv,
      parent,
      render(h) {
        return h(Popconfirm, {
          props,
          on: {
            cancel: () => resolve(),
            answer: val => resolve(val)
          }
        }, []);
      }
    });
  });
  promise.then(() => setTimeout(() => vueInst.$destroy(), 300));
  return promise;
}
//# sourceMappingURL=Popconfirm.js.map
